<template>
  <v-dialog v-model="showDialog" max-width="500">
    <v-card>
      <v-app-bar color="info" dark>
        <v-toolbar-title>Change Due Date</v-toolbar-title>
      </v-app-bar>
      <v-card-text>
        <v-row class="mt-4">
          <v-col>
            <p>
              Current Due Date:
              <span class="font-weight-bold">{{ assignee.due_date }}</span>
            </p>
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <v-menu
              ref="dueDateMenu"
              v-model="dueDateMenu"
              :close-on-content-click="false"
              transition="scale-transition"
              offset-y
              min-width="200px"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  v-validate="required"
                  v-model="dueDate"
                  @blur="temporaryDate = parseDate(dueDate)"
                  label="Pick a date"
                  prepend-icon="fal fa-calendar"
                  readonly
                  v-bind="attrs"
                  v-on="on"
                ></v-text-field>
              </template>
              <v-date-picker
                v-model="temporaryDate"
                no-title
                scrollable
                @input="dueDateMenu = false"
              >
              </v-date-picker>
            </v-menu>
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <v-btn color="primary" @click="updateDueDate"> Save </v-btn>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'UpdateDueDateDialog',
  props: {
    refreshTable: {
      type: Function,
    },
  },
  data() {
    return {
      dueDateMenu: false,
      dueDate: null,
      temporaryDate: null,
    };
  },
  watch: {
    temporaryDate(value) {
      this.dueDate = this.formatDate(value);
    },
  },
  computed: {
    showDialog: {
      get() {
        return this.$store.state.playlist.showUpdateDueDateDialog;
      },
      set(value) {
        this.$store.dispatch('playlist/setShowUpdateDueDateDialog', value);
      },
    },
    assignee() {
      return this.$store.state.playlist.selectedAssignee;
    },
  },
  methods: {
    formatDate(date) {
      if (!date) return null;
      const [year, month, day] = date.split('-');
      return `${month}/${day}/${year}`;
    },
    parseDate(date) {
      if (!date) return null;
      const [month, day, year] = date.split('/');
      return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`;
    },
    updateDueDate() {
      this.$http
        .patch(`playlist/${this.assignee.playlist_id}/assignees`, {
          assignee_id: this.assignee.id,
          assigned_by: this.assignee.assigned_by,
          playlist_id: this.assignee.playlist_id,
          due_date: this.dueDate,
        })
        .then(({ data }) => {
          this.refreshTable();
          this.$nextTick(() => {
            this.$notify('success', 'Due date updated!');
            this.$store.dispatch('playlist/setShowUpdateDueDateDialog', false);
            this.$store.dispatch('playlist/setSelectedAssignee', {});
          });
        });
    },
  },
};
</script>

<style scoped></style>
